/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Daftar_S2Inputs */

const en_mk_tut_daftar_s2 = /** @type {(inputs: Mk_Tut_Daftar_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otherwise fill in **Work email** and press **Send sign-in code**. Six digits arrive in your inbox; type them in.`)
};

const id_mk_tut_daftar_s2 = /** @type {(inputs: Mk_Tut_Daftar_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau tidak, isi kolom **Email kerja** dan tekan **Kirim kode masuk**. Enam angka dikirim ke email Anda; masukkan angka itu.`)
};

/**
* | output |
* | --- |
* | "Otherwise fill in **Work email** and press **Send sign-in code**. Six digits arrive in your inbox; type them in." |
*
* @param {Mk_Tut_Daftar_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_daftar_s2 = /** @type {((inputs?: Mk_Tut_Daftar_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Daftar_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_daftar_s2(inputs)
	return en_mk_tut_daftar_s2(inputs)
});